import apiClient from './apiClient';

export const login = async (credentials) => {
  const response = await apiClient.post('/accounts/login', credentials);
  return response.data;
};

export const register = async (userData) => {
  const response = await apiClient.post('/accounts/register', userData);
  return response.data;
};

/**
 * Fetch the user's trading defaults — used for risk-context display on the
 * Review-trade screen (account balance, currency, default risk %, max
 * concurrent trades).
 *
 * @returns {Promise<{ tradingDefaults: { accountBalance: number, accountCurrency: string, defaultRiskPerTrade: number, maxConcurrentTrades: number } }>}
 */
export const getTradingDefaults = async () => {
  const response = await apiClient.get('/account/trading-defaults');
  return response.data;
};

/**
 * Update one or more of the user's trading defaults. Partial-update — fields
 * omitted from `partial` are left unchanged. Backend validates: accountBalance
 * positive, accountCurrency in {USD,GBP,EUR}, defaultRiskPerTrade in (0,1],
 * maxConcurrentTrades integer in [1,20].
 *
 * @param {{ accountBalance?: number, accountCurrency?: string, defaultRiskPerTrade?: number, maxConcurrentTrades?: number }} partial
 * @returns {Promise<{ tradingDefaults: { accountBalance: number, accountCurrency: string, defaultRiskPerTrade: number, maxConcurrentTrades: number } }>}
 */
export const updateTradingDefaults = async (partial) => {
  const response = await apiClient.put('/account/trading-defaults', partial);
  return response.data;
};
